import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { and } from 'ember-truth-helpers';

interface TransactionCellsTdButtonSignature {
  Args: {
    value: {
      buttonType?: 'primary' | 'secondary';
      disabledText?: string;
      iconBefore?: IconName;
      isDisabled?: boolean;
      isLoading?: boolean;
      label: string;
      onClick: () => void;
    } | null;
  };
}

const TransactionCellsTdButton = <template>
  {{#if @value}}
    <PrismButton
      @buttonType={{@value.buttonType}}
      @iconBefore={{@value.iconBefore}}
      @isDisabled={{@value.isDisabled}}
      @isLoading={{@value.isLoading}}
      @label={{@value.label}}
      @onClick={{@value.onClick}}
      @size="small"
      class="w-full"
    />

    {{#if (and @value.isDisabled @value.disabledText)}}
      {{! @glint-expect-error: Incorrect type }}
      <PrismTooltip @text={{@value.disabledText}} />
    {{/if}}
  {{/if}}
</template> satisfies TOC<TransactionCellsTdButtonSignature>;

export default TransactionCellsTdButton;
